/* eslint-disable no-throw-literal */
import React, { useRef, useState } from 'react'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import { useRouter } from 'next/navigation'
import { useMatchWindowQuery } from '@wiggot/web-components/hooks/ds/useMatchWindowQuery'
import { getPropertyDetail } from '@/services/property-detail.services'

export const SearchPropertyById = () => {
  const router = useRouter()
  const { isXXL } = useMatchWindowQuery()
  const [searchByIdError, setSearchByIdError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const hasError = searchByIdError.length > 0
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSearchById = async (id: string) => {
    const wiggotId = id?.trim()
    try {
      setIsLoading(true)
      const { isSuccess, data } = await getPropertyDetail({
        id: wiggotId
      })
      if (
        isSuccess &&
        data &&
        data?.property?.publishingStatus !== 'PUBLISHED'
      ) {
        throw {
          data: {
            error: {
              code: 'NOT_PUBLISHED'
            }
          }
        }
      }
      if (!data) {
        throw {
          data: {
            error: {
              code: 'NOT_PUBLISHED'
            }
          }
        }
      }
      router.push(`/property-detail/${wiggotId}`)
    } catch (err: any) {
      setIsLoading(false)
      let errorMessage = ''
      try {
        const errorResponse = err as { data: { error: { code: string } } }
        const {
          data: {
            error: { code }
          }
        } = errorResponse

        switch (code) {
          case 'REQUIRED':
            errorMessage = 'El ID de propiedad no existe'
            break
          case 'VALIDATION_ERROR':
            errorMessage = 'El ID de propiedad no existe'
            break
          case 'NOT_FOUND':
            errorMessage = 'La propiedad ya no está disponible'
            break
          case 'NOT_PUBLISHED':
            errorMessage = 'La propiedad no está disponible'
            break
          default:
            errorMessage = 'Error, intenta mas tarde.'
            break
        }
      } catch (error) {
        errorMessage = 'El ID de propiedad no existe'
      }
      setSearchByIdError(errorMessage)
    }
  }
  const handleOnClick = () => {
    return handleSearchById(inputValue)
  }

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
    if (hasError) {
      setSearchByIdError('')
    }
  }

  const handleOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'Enter') {
      handleOnClick()
    }
  }
  const onCleanInput = () => {
    setInputValue('')
    setIsFocused(true)
    setSearchByIdError('')
    inputRef.current?.focus()
  }
  const focusVariant = isFocused || inputValue.length > 0
  const getButtonStyle = () => {
    if (hasError) {
      return 'border-2 border-notif-red bg-white flex-row-reverse'
    }
    if (focusVariant) {
      return 'border-2 border-black bg-white flex-row-reverse'
    }
    return 'border border-surface-strokes'
  }
  const buttonStyle = getButtonStyle()

  if (isXXL || focusVariant) {
    return (
      <div className="flex flex-col">
        <div
          className={[
            'flex gap-1 items-center justify-end rounded-full py-[6px] px-4 2xl:py-[9.5px] 2xl:pl-4 2xl:pr-3',
            buttonStyle
          ].join(' ')}
          onFocus={() => {
            setIsFocused(true)
            inputRef.current?.focus()
          }}
          onBlur={() => {
            setIsFocused(false)
          }}
        >
          {focusVariant && !isLoading && (
            <div className="w-full flex justify-end">
              <button
                onClick={onCleanInput}
                className={`${
                  inputValue.length > 0 ? 'opacity-1' : 'opacity-0'
                } flex !h-fit !w-fit transition-all`}
                type="button"
              >
                <GoogleIcon
                  className={hasError ? 'text-notif-red' : 'text-primary'}
                  name="cancel"
                />
              </button>
            </div>
          )}
          {isLoading && (
            <GoogleIcon className="animate-spin" name="progress_activity" />
          )}
          <input
            ref={inputRef}
            value={inputValue}
            onKeyDown={handleOnKeyDown}
            onBlur={() => {
              if (inputValue?.length > 0) {
                handleSearchById(inputValue)
              }
            }}
            onChange={handleOnChange}
            className="h-full max-w-[5.2rem] text-primary font-normal outline-none text-text-primary bg-transparent placeholder:text-primary placeholder:opacity-100 placeholder:text-sm"
            inputMode="text"
            type="text"
            placeholder={isFocused ? undefined : 'Buscar por ID'}
          />
          <GoogleIcon className="text-base leading-4" name="qr_code_2" />
        </div>
        <p className="text-xs text-notif-red whitespace-nowrap">
          {searchByIdError}
        </p>
      </div>
    )
  }
  return (
    <button
      type="button"
      className={[
        'flex gap-1 items-center justify-start rounded-full p-3 2xl:py-[11px] 2xl:pl-4 2xl:pr-3',
        buttonStyle
      ].join(' ')}
      onClick={() => {
        setIsFocused(true)
        setTimeout(() => {
          inputRef.current?.focus()
        }, 200)
      }}
    >
      <GoogleIcon className="text-base leading-4" name="qr_code_2" />
    </button>
  )
}
